import { API_BASE_URL } from '../../envConfig'

import { client } from '../moovyAxiosClient'
import { InvoiceListDTO } from './dto'

const apiUrl = `${API_BASE_URL}/v1`

const getInvoices = (licensePlate: string) => {
  return client.get<InvoiceListDTO>(`${apiUrl}/invoices`, {
    params: {
      licensePlate,
    },
  })
}

export default {
  getInvoices,
}
